import script from "./ToolSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ToolSidebar.vue?vue&type=style&index=0&id=1a629f89&lang=css"

const __exports__ = script;

export default __exports__